/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Light_Crow_SwimInputs */

const en_wise_light_crow_swim = /** @type {(inputs: Wise_Light_Crow_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const de_wise_light_crow_swim = /** @type {(inputs: Wise_Light_Crow_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

/**
* | output |
* | --- |
* | "Filter" |
*
* @param {Wise_Light_Crow_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_light_crow_swim = /** @type {((inputs?: Wise_Light_Crow_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Light_Crow_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_light_crow_swim(inputs)
	return de_wise_light_crow_swim(inputs)
});